"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var CookieStrategy = /** @class */ (function () {
    function CookieStrategy(cookieDomain, currentDomain) {
        this.BEGINNING_OF_TIME = "Thu, 01 Jan 1970 00:00:01 GMT";
        this.SAMESITES = {
            'appuserid': 'Strict',
            'accesstoken': 'Lax',
            'usu_tiendeo': 'None'
        };
        this.COOKIE_DOMAIN = cookieDomain;
        this.currentDomain = currentDomain;
    }
    CookieStrategy.prototype.Delete = function (name) {
        this.Set(name, "", -Infinity);
    };
    CookieStrategy.prototype._getExpireDate = function (hoursFromNow) {
        var date = new Date();
        date.setTime(date.getTime() + (hoursFromNow * 60 * 60 * 1000));
        return date;
    };
    return CookieStrategy;
}());
exports.default = CookieStrategy;
//# sourceMappingURL=CookieStrategy.js.map